import { ActionButton, PrimaryButton } from '@fluentui/react';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { ConstantField } from '@shared/types/flowstep/mapping';
import { ConstantMappingsState } from './constant-mapping-state';
import { ColumnFieldMappingEditorState } from '../ColumnFieldMapping/ColumnFieldMappingEditor';
import { ConstantMappingEditor, ConstantMappingEditorState } from './ConstantMappingEditor/ConstantMappingEditor';
import { useStyles } from './ConstantMappings.styles';
import { DataField } from 'shared/providers/types';
import { RenderFieldEditorFunc } from 'src/v2/components/controls/editors/types';

interface ConstantMappingsProps {
  objectType: string;
  constantFields: ConstantField[];
  objectFields: DataField[];
  mappingFields: ColumnFieldMappingEditorState[];
  renderEditorForType: RenderFieldEditorFunc;
  onApplyResult: (result: ConstantField[]) => void;
}

export const ConstantMappings: React.FC<ConstantMappingsProps> = observer((props) => {
  const { objectType, constantFields, objectFields, mappingFields, onApplyResult, renderEditorForType } = props;
  const styles = useStyles();

  const [state] = useState(() => new ConstantMappingsState(constantFields, mappingFields));

  useEffect(() => {
    state.initialize(objectFields);
  }, []);

  const handleAddConstant = () => {
    state.addConstant(objectFields);
  }

  const handleDeleteConstant = (index: number) => {
    state.deleteConstant(index);
  }

  const handleApply = () => {
    onApplyResult(state.buildContantFields(objectFields, objectType));
  }

  const renderConstantEditor = (editorState: ConstantMappingEditorState, index: number) => (
    <div key={editorState.fieldName}>
      <div className={styles.constantHeader}>
        <span>{`Constant #${index + 1}`}</span>
        <ActionButton
          iconProps={{ iconName: 'RecycleBin' }}
          onClick={() => handleDeleteConstant(index)}
        >
          Delete
        </ActionButton>
      </div>
      <ConstantMappingEditor key={index} state={editorState} objectFields={objectFields} errorMessage={state.validationErrors.get(index.toString())} renderEditorForType={renderEditorForType} />
    </div>
  )

  return (
    <div className={styles.constantMappings}>
      {state.editorStates.map((editorState, index) =>
        renderConstantEditor(editorState, index))
      }
      <ActionButton
        className={styles.addButton}
        iconProps={{ iconName: 'addTo' }}
        onClick={() => handleAddConstant()}
      >
        Add Constant
      </ActionButton>
      <PrimaryButton onClick={handleApply} disabled={state.validationErrors.size > 0}>Apply</PrimaryButton>
    </div>
  );
})
